// 64px exceeds the floating shadow-lg drop layers' offset + blur + spread.
// Share that clearance across both halves so clipping removes only the joined edge.
export const composerShadowGeometry = {
    overhang: '[--composer-overhang:64px]',
    extendTop: 'after:top-[calc(-1*var(--composer-overhang))] after:[clip-path:inset(var(--composer-overhang)_calc(-1*var(--composer-overhang))_calc(-1*var(--composer-overhang)))]',
    extendBottom: 'after:bottom-[calc(-1*var(--composer-overhang))] after:[clip-path:inset(calc(-1*var(--composer-overhang))_calc(-1*var(--composer-overhang))_var(--composer-overhang))]',
    clipTop: '[clip-path:inset(0_calc(-1*var(--composer-overhang))_calc(-1*var(--composer-overhang)))]',
    clipBottom: '[clip-path:inset(calc(-1*var(--composer-overhang))_calc(-1*var(--composer-overhang))_0)]',
};
//# sourceMappingURL=shadowGeometry.js.map